import React, { useState, useCallback } from 'react';
import cn from 'classnames';
import styles from './TripAndCharge.module.scss';
import Gantt from '../echarts/viewGantt';
import Calendar from 'shared/Calendar';

function ViewTripCharge(){
    let currentday=new Date().getDay()
    if(currentday===0){
      currentday=7
    }
  let currentDate=new Date()
  let Urls = window.location.href.toString().split(window.location.host)[1]

  let checkBoxCheked = localStorage.getItem('TripSechedule')
  var addbuttonClick = 'edit';
  var [selectedDay, setSelectedDay] = useState(currentday-1);
  // const [dateValue, onChange] = useState(new Date());
  const [chargertripstate, setChargerTripState] = useState(checkBoxCheked)
  const [selectedDate, setSelectedSate] = useState()
  const [viewtrip, setviewtrip] = useState(true)
//   const [secondPopup, setSecondPopup] = useState('false')
//   const [addtripcharge, setAddTripCharge] = useState('edit')
  const [nextPrevious,setnextPrevious]=useState('')
  const [todaydate,setTodaydate]=useState('')
 
  const selectDate = useCallback((data,day) => {
    setTodaydate('');
    if(data!==''){
    if(day!=undefined){
      setSelectedDay(day-1)
     }else{
      
     }
     setSelectedSate(data)
    }
    // setSelectedSate(data)
  }, []);
  const today=()=>{
    let startDate = new Date()
    let dd = String(startDate.getDate()).padStart(2, '0');
    let mm = String(startDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = startDate.getFullYear();
    var date = mm + '/' + dd + '/' + yyyy;
    setSelectedDay(currentday-1);
    setSelectedSate(date)
    setTodaydate(date);
  }
  var date = selectedDate;
  function handleChange(evt) {
    setChargerTripState(evt.target.value)
  }
  

  

 const nextWeak=(e)=>{
  setnextPrevious(e)
 }
    return(
       <>
        <div className={cn(styles.filter, styles.filter_layout)}>
            <div className={cn(styles.filter_item)}>
              <div className={cn(styles.options_block, styles.options_block_layout)}>
                <div className={cn(styles.option_flex, styles.option_flex_layout)}>
                  <label className={cn(styles.customCheckbox)}>
                    <input type="radio" checked={chargertripstate === 'Charging Schedule' ? true : false} id="charging_schedule" name="Charging_trip_Schedule" onChange={handleChange} value="Charging Schedule" />
                    <span className={cn(styles.checkmarkDropdown)}></span>
                  </label>
                  {/* <input type="radio" checked={chargertripstate==='Charging Schedule'?true:false}  id="charging_schedule" name="Charging_trip_Schedule" onChange={handleChange} value="Charging Schedule" /> */}
                  {/* <div className={cn(styles.option_flex_item)}>
                    <img
                      src={
                        require('assets/arrow.svg')
                          .default
                      }
                      alt="Rectangle 1069"
                      className={cn(styles.box10, styles.box10_layout)}
                    />
                    </div>*/}
                  <div className={cn(styles.option_flex_spacer)} />
                  <h3 className={cn(styles.subb_title_text, styles.subTitle_midiumBold, styles.subb_title_text_layout)}>
                    {'Charging Schedule'}
                  </h3>
                  <div className={cn(styles.option_flex_spacer1)} />
                  {/* <div className={cn(styles.option_flex_item1)}>
                    <img
                      src={
                        require('assets/arrow.svg')
                          .default
                      }
                      alt="Rectangle 1070"
                      className={cn(styles.box10, styles.box10_layout1)}
                    />
                  </div> */}
                  <label className={cn(styles.customCheckbox)}>
                    <input type="radio" id="trip_schedule" checked={chargertripstate === 'Trip Schedule' ? true : false} name="Charging_trip_Schedule" onChange={handleChange} value="Trip Schedule" />
                    <span className={cn(styles.checkmarkDropdown)}></span>
                  </label>
                  <div className={cn(styles.option_flex_spacer2)} />
                  <h3 className={cn(styles.subb_title_text, styles.subTitle_midiumBold, styles.subb_title_text_layout)}>
                    {'Trip Schedule'}
                  </h3>
                </div>
              </div>
            </div>
            <h3 className={cn(styles.subb_title_text, styles.titlebold, styles.subb_title_text_layout1)}>
              {'Date:'}
            </h3>
            <div className={cn(styles.filter_spacer)} />
            <div className={cn(styles.filter_item1)}>
              <div className={cn(styles.datepicker_block, styles.datepicker_block_layout)}>
                {/* <div className={cn(styles.flex5, styles.flex5_layout)}>
                  <div
                    className={cn(
                      styles.normal_text,
                      styles.normal_text_layout
                    )}>
                    {'{{set.opt 1}}'}
                  </div>
                  
                  <div className={cn(styles.flex5_spacer)} />
                  <div className={cn(styles.flex5_item)}>
                    <img
                      src={
                        require('assets/arrow.svg')
                          .default
                      }
                      alt="Rectangle 1071"
                      className={cn(styles.box10, styles.box10_layout2)}
                    />
                  </div>
                </div> */}
                {/* 
            <DatePicker onChange={onChange} value={dateValue} format={"d-MM-yyyy"} />
            <div style={{"position":"absolute","right":'5px','top':'7px','zIndex':'0'}}>
            <img src={
                  require('assets/calendar.svg')
                    .default
                }/>
            </div> */}
                <Calendar dateCallback={selectDate} todaydateSelected={todaydate} nextPreviousWeak={nextPrevious} changedate={selectedDay}  />
              </div>
            </div>
            <div className={cn(styles.filter_spacer1)} />
            <div className={cn(styles.filter_item2)}>
              <div
                className={cn(styles.cover_block9, styles.cover_block9_layout)}>
                <div onClick={() => today()}
                  className={cn(
                    styles.normal_text1,
                    styles.normal_text1_layout
                  )}>
                  {'Today'}
                </div>
              </div>
            </div>
            <div className={cn(styles.filter_spacer2)} />
            {/* <h3 className={cn(styles.subb_title_text, styles.subTitle_midiumBold,styles.subb_title_text_layout2)}>
          {'Auto Copy Schedule'}
        </h3> */}
            {/* <div className={cn(styles.filter_spacer3)} />
        <div className={cn(styles.filter_item3)}>
          <div
            className={cn(styles.on_block, styles.on_block_layout)}
            onClick={() => alert('It is clickable')}>
            <div className={cn(styles.on_box, styles.on_box_layout)} />
            <div
              className={cn(
                styles.normal_text,
                styles.normal_text_layout1
              )}>
              {'On'}
            </div>
          </div>
        </div>
        <div className={cn(styles.filter_item4)}>
          <div
            className={cn(styles.off_block, styles.off_block_layout)}
            onClick={() => alert('It is clickable')}>
            <div className={cn(styles.off_box, styles.off_box_layout)} />
            <div
              className={cn(
                styles.normal_text2,
                styles.normal_text2_layout
              )}>
              {'Off'}
            </div>
          </div>
        </div> */}
            <div className={cn(styles.filter_spacer5)} />
            {/* <div className={cn(styles.filter_item2)}>
              <div
                className={cn(styles.cover_block9, styles.cover_block9_layout)}>

              </div>
            </div> */}
            <div className={cn(styles.filter_spacer5)} />
            <div className={cn(styles.filter_item5)}>
              {/* {Urls !== '/TripAndChargeSchedule' ?
                <div
                  className={cn(styles.cover_block9, styles.cover_block9_layout)}>
                  <div onClick={(e) => addHandleChange(true)}
                    className={cn(
                      styles.normal_text1,
                      styles.normal_text1_layout
                    )}>
                    {'Add Schedule'}
                  </div>
                </div> : ''} */}
            </div>
          </div>


          <div className={cn(styles.site_group, styles.site_group_view_layout)} >


            <div className={cn(styles.table)}>

              <div
                className={cn(styles.site_box, styles.table__cell__site)}
              // className={cn(styles.site_box, styles.site_box_layout)}
              >
                <div className={cn(styles.overlapText)}>
                  <h3 className={cn(styles.subb_title_text8, styles.subb_title_text8_layout)}>
                    {chargertripstate === 'Trip Schedule' ? 'Vehicles List' : 'Chargers List'}
                  </h3>
                </div>



                <div
                  className={cn(styles.site_list_block, styles.site_list_block_layout)}>
                  <div className={cn(styles.site_text_body, styles.site_text_body_layout)}>
                    {''}
                  </div>
                </div>
              </div>

              <div
                className={selectedDay === 0 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.collapse_day_cover, styles.table__cell  ) }
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 0 ? styles.expand_day_head2_layout : ""))}

                    onClick={() => setSelectedDay(0)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 0 ? <div>Monday<br />{date} </div> : 'M'}
                      {/* {'M'} */}
                    </h3>
                  </div>


                </div>
              </div>

              <div
                className={selectedDay === 1 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.collapse_day_cover, styles.table__cell)}
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 1 ? styles.expand_day_head2_layout : ""))}

                    onClick={() => setSelectedDay(1)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 1 ? <div>Tuesday<br />{date} </div> : 'Tu'}
                      {/* {'TU'} */}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                className={selectedDay === 2 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.collapse_day_cover, styles.table__cell)}
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 2 ? styles.expand_day_head2_layout : ""))}

                    onClick={() => setSelectedDay(2)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 2 ? <div>Wednesday<br />{date} </div> : 'W'}
                      {/* {'W'} */}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                className={selectedDay === 3 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.collapse_day_cover, styles.table__cell)}
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 3 ? styles.expand_day_head2_layout : ""))}

                    onClick={() => setSelectedDay(3)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 3 ? <div>Thursday<br />{date} </div> : 'Th'}
                      {/* {'Th'} */}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                // className={cn(styles.collapse_day_cover, styles.table__cell)}
                className={selectedDay === 4 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div
                    className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 4 ? styles.expand_day_head2_layout : ""))}
                    onClick={() => setSelectedDay(4)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 4 ? <div>Friday<br />{date} </div> : 'F'}
                      {/* {'F'} */}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                className={selectedDay === 5 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.expand_day_cover, styles.table__cell__active)}

              // className={cn(styles.expand_day_cover, styles.expand_day_cover_layout)}
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 5 ? styles.expand_day_head2_layout : ""))}
                    // onClick={setSelectedDay(5)}
                    onClick={() => setSelectedDay(5)}
                  >
                    <h3 className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 5 ? <div>Saturday<br />{date} </div> : 'Sa'}
                      {/* {'Sa'} */}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                // className={cn(styles.collapse_day_cover, styles.table__cell)}
                className={selectedDay === 6 ? cn(styles.expand_day_cover, styles.table__cell__active) : cn(styles.collapse_day_cover, styles.table__cell)}

              // className={cn(styles.datepicker_block1, styles.datepicker_block1_layout)}
              >
                <div className={cn(styles.collapse_day_head_block, styles.collapse_day_head_block_layout)}>
                  <div
                    className={cn(styles.collapse_day_head2, styles.collapse_day_head2_layout, (selectedDay === 6 ? styles.expand_day_head2_layout : ""))}
                    // onClick={() => alert('It is clickable')}
                    onClick={() => setSelectedDay(6)}
                  // onClick={setSelectedDay(6)}
                  >
                    <div className={cn(styles.subb_title_text7, styles.subb_title_text7_layout)}>
                      {selectedDay === 6 ? <div>Sunday<br />{date} </div> : "Su"}

                      {/* {"Sunday \n"}
                  <br/>
                  {date} */}


                      {/* {'Su'} */}

                    </div>
                  </div>

                </div>
              </div>


            </div>

            <div className={cn(styles.datepicker_block1,
              chargertripstate === 'Trip Schedule' ? (selectedDay === 6 ? styles.datepicker_block1_layout_su : (selectedDay === 5 ? styles.datepicker_block1_layout_sa : (selectedDay === 4 ? styles.datepicker_block1_layout_f : (selectedDay === 3 ? styles.datepicker_block1_layout_th : (selectedDay === 2 ? styles.datepicker_block1_layout_w : (selectedDay === 1 ? styles.datepicker_block1_layout_tu : styles.datepicker_block1_layout_m))))))
                : (selectedDay === 6 ? styles.datepicker_block1_layout_su1 : (selectedDay === 5 ? styles.datepicker_block1_layout_sa1 : (selectedDay === 4 ? styles.datepicker_block1_layout_f1 : (selectedDay === 3 ? styles.datepicker_block1_layout_th1 : (selectedDay === 2 ? styles.datepicker_block1_layout_w1 : (selectedDay === 1 ? styles.datepicker_block1_layout_tu1 : styles.datepicker_block1_layout_m1))))))
            )}>
              <Gantt viewTripCharge={viewtrip}  chargerTripShedule={chargertripstate} gap={24 - ((6 - selectedDay) * 3.45)} day={selectedDay} />
            </div>



          </div>

          <div className={cn(styles.flex6, styles.flex6_layout)}>
            <h3
              className={cn(styles.subb_title_text10, styles.subb_title_text10_layout)}
              onClick={(e) => nextWeak('previous')}>
              {'< Previous Week'}
            </h3>
            <div className={cn(styles.flex6_spacer)} />
            <div className={cn(styles.flex6_item)}>
              {/* <div
            className={cn(styles.cover_block, styles.cover_block_layout)}
            onClick={() => alert('It is clickable')}>
            <h3 className={cn(styles.subb_title_text21, styles.subb_title_text21_layout)}>
              {'COPY SCHEDULE TO NEXT WEEK'}
            </h3>
          </div> */}
            </div>
            <div className={cn(styles.flex6_spacer1)} />
            <h3  onClick={(e) => nextWeak('next')} className={cn(styles.subb_title_text11, styles.subb_title_text11_layout)}>
              {'Next Week >'}
            </h3>
          </div>
       </>
    )
}
export default ViewTripCharge